const fileRegex = /.*\.(jpg|jpeg|gif|png|ico|css|csv|zip|tgz|gz|rar|bz2|pdf|txt|tar|wav|bmp|rtf|js|flv|swf|xml|html|htm|svg|map|json)$|(__webpack_hmr)$/;

export default fileRegex;
